import { cellNumberValidation, emailValidation } from "utils/phoneNumber";

const useUserNameValidation = (username) => {
  const emailValid = emailValidation(username);
  const cellphoneValidation =
    username.length == 11 ? cellNumberValidation(username) : false;
  return cellphoneValidation == emailValid ? false : true;
};
export default useUserNameValidation;
